module.exports = __webpack_public_path__ + "videos/whatsnew-selectioncolorfill_en.e1138e5.mp4";